export class Franchise {
    FID: number;
    Title: string;
    Code: number;
    CityCode: string;
    ParentFID?: number;
    ConstructionCo: string;
    LocationAddress: string;
    LocationCity: string;
    LocationState: string;
    LocationZip: number;
    ConstructionDays: number;
    SalesApproval: boolean;
    SalesDrafting: boolean;
    Sharepoint: string;
    JobFolder: string;
    EstimateFolder: string;
    LNumber: string;
    LDate?: Date;
    Library: string;
    Active: boolean;
    Longitude: string;
    Latitude: string;
    OfficePhone: string;
    LassoProjectID: number;
    LassoAPI: string;
    ApprovalDrafting: boolean;
    ConStartDays: number;
    FeeDefault: number;
    FeePercentage: boolean;
    BilledName: string;
    ParentDataFID: number;
    CorpOI: boolean;
    PreconApproval: boolean;
    PlanPrice_FID: number | null;
    Options_FID: number | null;
    Standards_FID: number | null;
    Bank_FID: number | null;
    Travel_FID: number | null;
    DefaultStateID: number;
    DefaultBuilder: number | null;
    franchise_phones: FranchisePhone[];

    constructor() {
        this.FID = 0;
        this.Title = '';
        this.Code = 0;
        this.CityCode = '';
        this.ConstructionCo = '';
        this.LocationAddress = '';
        this.LocationCity = '';
        this.LocationState = '';
        this.LocationZip = 0;
        this.ConstructionDays = 0;
        this.SalesApproval = false;
        this.SalesDrafting = false;
        this.Sharepoint = '';
        this.JobFolder = '';
        this.EstimateFolder = '';
        this.LNumber = '';
        this.Library = '';
        this.Active = false;
        this.Longitude = '';
        this.Latitude = '';
        this.OfficePhone = '';
        this.LassoProjectID = 0;
        this.LassoAPI = '';
        this.ApprovalDrafting = false;
        this.ConStartDays = 0;
        this.FeeDefault = 0;
        this.FeePercentage = false;
        this.BilledName = '';
        this.ParentDataFID = 0;
        this.CorpOI = false;
        this.PreconApproval = false;
        this.PlanPrice_FID = null;
        this.Options_FID = null;
        this.Standards_FID = null;
        this.Bank_FID = null;
        this.Travel_FID = null;
        this.DefaultStateID = 0;
        this.DefaultBuilder = null;
        this.franchise_phones = [];
    }
}

export interface FranchisePhone {
    id: number;
    fid: number;
    number: string;
    extension: string;
    label: string;
    is_active: boolean;
    created_at: Date;
}
